export const signInConfig = {
	isSignUpEnabled: true
}
